module.exports = __webpack_public_path__ + "static/media/audius.f2407b47.png";